export function getDisplayTitleAndImage(eventInfo, isChinese, isMobile) {
  if (!eventInfo) return { title: "", description: "", image: "" };

  const title = isChinese ? eventInfo.title_hk : eventInfo.title_hk_en;
  const description = isChinese ? eventInfo.html_hk : eventInfo.html_hk_en;
  let image = "";

  if (isMobile) {
    image = isChinese ? eventInfo.mobile_tc_img : eventInfo.mobile_en_img;
  } else {
    image = isChinese ? eventInfo.desktop_tc_img : eventInfo.desktop_en_img;
  }

  return { title, description, image };
}
